import {Quiz, QuizStatsSum, QuizStatsSumRecord} from "../../../../@types/Quiz";

export const parseQuizStatsSummary = (quiz: Quiz): Record<string, QuizStatsSum> => {
    return quiz.stats ? quiz.stats : {};
}

export const getQuizStatUserKey = (userId: string) => userId.replaceAll('-', '_');

export const getUserResultFromQuiz = (quiz: Quiz, userId: string): QuizStatsSum | undefined => {
    return parseQuizStatsSummary(quiz)[getQuizStatUserKey(userId)];
}

export const getUsersCompletedCount = (stats: QuizStatsSumRecord) => {
    if (!stats) {
        return 0;
    }

    return Object.values(stats).filter(resultSum => resultSum.completedAt).length;
}
